/* eslint-disable  no-underscore-dangle, max-len */

import Promise from 'bluebird';
import $ from 'jquery';
import _ from 'underscore';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { DeterministicView } from '@bingads-webui/deterministic-view';
import { Dialog } from '@bingads-webui/dialog';
import { withUiBlock } from '@bingads-webui/uiblocker';
import { bulkEditParams, bulkEditService } from '../hotel-center-service';
import HotelsInGroupView from '../hotel-in-group/hotel-in-group';
import HotelOutGroupOptions from '../hotel-out-group/hotel-out-group';
import template from './template.pug';
import InformationView from '../assignment-utils/Information-view';


const i18n = globalContext.require('component/i18n/loader!campaignui/feature/hotel-center');
const { getCustomUserInfos, setCustomUserInfos } = globalContext.require('component/bingads-grid/service/custom-userinfo-preferences');
const state = globalContext.require('component/state/index');
const pageContext = globalContext.require('PageContext');
const permissions = pageContext && pageContext.Permissions;
const project = 'CampaignUIHotelCenter';
/**
 * Class representing a navigation tabs for HotelAssociations
 * @extends View
 */
export default class HotelAssociations extends DeterministicView {
  /**
  * Initializes HotelAssociations
  * @returns {undefined}
  */
  initialize({
    perfMarker,
    isUINext = false,
    preferenceStoreFactory,
    preferenceService,
    sessionStore,
  } = {}) {
    this.i18n = i18n;
    this.isUINext = isUINext;
    this.isHotelCenterDeprecation = permissions && permissions.dynamic.HotelCenterDeprecation;

    const hotelsInGroup = new HotelsInGroupView({
      perfMarker,
      isUINext,
      preferenceStoreFactory,
      preferenceService,
      sessionStore,
    });
    const hotelsOutGroup = new HotelOutGroupOptions({
      perfMarker,
      isUINext,
      preferenceStoreFactory,
      preferenceService,
      sessionStore,
    });

    this.listenTo(hotelsInGroup, 'selectionRenamed', this.onSelectionRenamed);
    this.listenTo(hotelsInGroup, 'selectionDeleted', this.onSelectionDeleted);
    this.listenTo(hotelsInGroup, 'selectionChanged', this.onHotelInGroupSelectionChanged);
    this.listenTo(hotelsOutGroup, 'selectionChanged', this.onHotelOutGroupSelectionChanged);

    this.setChild('hotels-in-group', hotelsInGroup);
    this.setChild('hotels-out-group', hotelsOutGroup);
    getCustomUserInfos(project).then((result) => {
      this.hasShowedAssociateAttention = result ? _.result(result, 'hasShowedAssociateAttention') : false;
    });
    this.model.set('noSubAccount', false);
  }

  get events() {
    return {
      'click .associate-button': this.onAssociate,
      'click .disassociate-button': this.onDisassociate,
    };
  }

  setState({
    selectedGroup,
    ungroupedGroupId,
    selectedSubAccount,
    isSubAccountSelected,
    noSubAccount,
  }) {
    if (noSubAccount) {
      this.model.set('noSubAccount', true);
    } else {
      this.isSubAccountSelected = isSubAccountSelected;
      // when subAccount is selected, set selectedGroup as ungrouped in the selected subAccount and set subAccount Id as null
      // when hotel group is selected, set subAccount Id as current selected hotel group subaccount
      // ungrouped GroupId will always set as current selected subAccount/hotelGroup related ungrouped group id
      this.selectedGroup = selectedGroup;
      // when ungrouped group is selected
      this.ungroupedGroupId = ungroupedGroupId === selectedGroup.Id ? '' : ungroupedGroupId;
      const isUnGrouped = selectedGroup.Name === 'UnGrouped' || selectedGroup.Name === 'Ungrouped';

      this.getChild('hotels-in-group').setState({
        groupId: selectedGroup.Id,
        groupName: isSubAccountSelected ? selectedSubAccount.Name : selectedGroup.Name,
        showEditMenu: isSubAccountSelected || !isUnGrouped,
        subAccountId: selectedSubAccount.Id,
        isSubAccountSelected,
      });
      this.getChild('hotels-in-group').setAssociationBarState({ statusMessage: '', errorMessage: '' });
      this.getChild('hotels-out-group').setState({
        groupId: selectedGroup.Id,
        groupName: i18n.getString('HotelCenter_Group_Others_Label'),
        excludeGroupId: selectedGroup.Id,
        showEditMenu: false,
        subAccountId: selectedSubAccount.Id,
      });

      this.model.set('isAssociationEnabled', false);
      this.model.set('isDisassociationEnabled', false);
      this.model.set('noSubAccount', false);
    }
  }

  get template() {
    return template;
  }

  onHotelInGroupSelectionChanged(selections) {
    this.model.set('isDisassociationEnabled', selections.length > 0);
  }

  onHotelOutGroupSelectionChanged(selections) {
    this.model.set('isAssociationEnabled', selections.length > 0);
  }

  _refreshAssociationButtonStates() {
    this.model.set(
      'isDisassociationEnabled',
      this.getChild('hotels-in-group').getSelectedItems().length > 0
    );

    this.model.set(
      'isAssociationEnabled',
      this.getChild('hotels-out-group').getSelectedItems().length > 0
    );
  }

  onAssociate() {
    if (this.isUINext && !this.model.get('isAssociationEnabled')) {
      return;
    }

    this.showAssociateAttention(() => this._makeAssociationCallAsync({
      selectionCount: this.getChild('hotels-out-group').getSelectionCount(),
      selectedIds: _.pluck(this.getChild('hotels-out-group').getSelectedItems(), 'HotelId'),
      idAttribute: 'HotelId',
      filter: this.getChild('hotels-out-group').getFilter(),
      hotelGroupId: this.selectedGroup.Id,
    }).then(() => {
      this.getChild('hotels-out-group').clearSelection();
      this._refreshAssociationButtonStates();
      this.trigger('associationChanged');
    }));
  }

  onDisassociate() {
    if (this.isUINext && !this.model.get('isDisassociationEnabled')) {
      return;
    }

    const selectionCount = this.getChild('hotels-in-group').getSelectionCount();
    const selectedIds = _.pluck(this.getChild('hotels-in-group').getSelectedItems(), 'Id');
    const isCrossPage = selectionCount > selectedIds.length;
    const options = {
      selectionCount,
      selectedIds,
      idAttribute: 'HotelId',
      filter: this.getChild('hotels-in-group').getFilter(),
      hotelGroupId: this.ungroupedGroupId ? this.ungroupedGroupId : null,
    };

    if (!this.isSubAccountSelected && this.selectedGroup && isCrossPage) {
      options.customStrFilter = `HotelGroupId eq '${this.selectedGroup.Id}'`;
    }

    this.showAssociateAttention(() => this._makeAssociationCallAsync(options).then(() => {
      this.getChild('hotels-in-group').clearSelection();
      this._refreshAssociationButtonStates();
      this.trigger('associationChanged');
    }));
  }

  onSelectionRenamed() {
    this.trigger('selectionModified', this.selectedGroup);
  }

  onSelectionDeleted() {
    this.trigger('selectionDeleted', this.selectedGroup);
  }

  showAssociateAttention(callback) {
    const isSubAccountLevel = state.get('subAccount_id') === '';

    if (isSubAccountLevel && !this.hasShowedAssociateAttention) {
      this._showAssociateAttentionDialog(callback);
    } else {
      callback();
    }
  }

  _showAssociateAttentionDialog(callback) {
    const attentionView = new InformationView({ name: 'attentionView' }).setState({
      content: i18n.getString('HotelCenter_Assignment_Associate_Attention_Dialog_Content'),
      isDismiss: false,
    });
    const dialog = new Dialog({ className: 'hotel-center-associate-attention-dialog' }).setContent(attentionView).setState({
      title: i18n.getString('HotelCenter_Assignment_Associate_Attention_Dialog_Title'),
      buttons: [{
        text: i18n.getString('HotelCenter_Shared_OK'),
        name: 'confirm',
        class: 'hotel-center-associate-attention-dialog-save',
      }, {
        text: i18n.getString('HotelCenter_Shared_Cancel'),
        name: 'cancel',
        class: 'dialog-cancel',
      }],
    });

    document.body.appendChild(dialog.el);
    dialog.show();

    dialog.on('clickedButton', (name) => {
      if (name === 'confirm') {
        if (attentionView.getState().isDismiss) {
          // write to preference setting and won't show again
          setCustomUserInfos({ hasShowedAssociateAttention: true }, project);
          this.hasShowedAssociateAttention = true;
        }
        dialog.remove();
        callback();
      } else {
        dialog.remove();
      }
    });
  }

  _makeAssociationCallAsync({
    selectionCount,
    selectedIds,
    idAttribute,
    filter,
    customStrFilter,
    hotelGroupId,
  }) {
    this.getChild('hotels-in-group').setAssociationBarState({
      statusMessage: i18n.getString('HotelCenter_Group_Association_Status_Saving'),
      errorMessage: '',
    });

    return new Promise((resolve, reject) => {
      bulkEditService.save({
        params: bulkEditParams({
          selectionCount,
          selectedIds,
          idAttribute,
          filter,
          customStrFilter,
          batchActions: {
            Actions: [{
              '@odata.type': '#Model.NumericAction',
              ActionType: 'SetToAmount',
              Limit: null,
              Value: hotelGroupId,
              Property: 'HotelGroupId',
            }],
            EditCopy: false,
          },
          entity: 'HotelAssociation',
          // bulk edit API uses field campaignId to pass subaccount id
          campaignId: Number(this.getChild('hotels-in-group').getState().subAccountId),
        }),
        completeCB: _.bind(resolve, this),
        failedCB: _.bind(reject, this),
      });
    }).then((response) => {
      this.getChild('hotels-out-group').refreshGrid();

      const hotelsInGroup = this.getChild('hotels-in-group');

      hotelsInGroup.refreshGrid();

      const errorCount = response.ErrorRowCount;
      // partial success

      if (errorCount > 0) {
        hotelsInGroup.setAssociationBarState({
          statusMessage: '',
          errorMessage: i18n.getString('HotelCenter_Group_Association_Failed_Format', errorCount, selectionCount),
        });
      } else {
        hotelsInGroup.setAssociationBarState({
          statusMessage: i18n.getString('HotelCenter_Group_Association_Status_Saved'),
          errorMessage: '',
        });
      }
    }).catch(() => {
      this.getChild('hotels-in-group').setAssociationBarState({
        statusMessage: '',
        errorMessage: i18n.getString('HotelCenter_Group_Association_Failed_Generic'),
      });
    }).finally(withUiBlock($('.hotel-associations__container')));
  }
}
